import * as React from "react";

import { DashboardApprenantsNonInscrits, DashboardInscriptionsEnCours } from ".";

export interface IDashboardInscriptionsProps {
}

export const DashboardInscriptions: React.FunctionComponent<IDashboardInscriptionsProps> = props => {
  return (
    <>
      <DashboardInscriptionsEnCours />
      <DashboardApprenantsNonInscrits />
    </>
  );
};
